import { render, staticRenderFns } from "./PricePhilips.vue?vue&type=template&id=c17e70e8&scoped=true"
import script from "./PricePhilips.vue?vue&type=script&lang=js"
export * from "./PricePhilips.vue?vue&type=script&lang=js"
import style0 from "./PricePhilips.vue?vue&type=style&index=0&id=c17e70e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17e70e8",
  null
  
)

export default component.exports